<mat-form-field
    [appearance]="appearance"
    class="{{ customClass }} praxis-datepicker"
    fxLayout="column"
    fxLayoutAlign="start center"
>
    <mat-label [ngClass]="labelClass ? 'form-label' : ''">{{ label }}</mat-label>
    <input
        class="w-100-p"
        (click)="index.open()"
        [formControl]="control"
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="index"
        (dateChange)="dateChange($event)"
        matInput
        [required]="required"
        placeholder="{{ label }}"
    />
    <!--<i
        (click)="control.setValue(null)"
        *ngIf="showClearButton"
        class="fas fa-times-circle font-weight-900 font-size-20 color-black-60 cursor-pointer date-picker-times-icon"
        matSuffix
    ></i>-->
    <mat-icon
        matSuffix
        (click)="control.setValue(null)"
        matRipple
        *ngIf="control.value && showClearButton"
        [matRippleRadius]="18"
        [matRippleAnimation]="{ enterDuration: 100, exitDuration: 1500 }"
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
        id="am-1373"
    >
        cancel
    </mat-icon>
    <mat-icon
        *ngIf="!(control.value && showClearButton) && !showClearButton"
        matSuffix
        (click)="index.opened ? index.close() : index.open()"
        matRipple
        [matRippleRadius]="18"
        [matRippleAnimation]="{ enterDuration: 100, exitDuration: 1500 }"
        [matRippleUnbounded]="true"
        [matRippleCentered]="true"
        id="am-1374"
    >
        today
    </mat-icon>
    <!--<mat-datepicker-toggle matSuffix [for]="index"></mat-datepicker-toggle>-->
    <mat-datepicker #index></mat-datepicker>
</mat-form-field>
